/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-11-29 22:40:48
 */

import React, { useEffect, useMemo, useRef, useState } from 'react'
import Tour from 'reactour'
import sensors from '../../utils/sensors'

const AddPhotoTour = () => {
  const [visible, setVisible] = useState(
    localStorage.getItem('jigsaw_add_photos_tour_showed') !== 'true'
  )

  const onClose = () => {
    setVisible(false)
    localStorage.setItem('jigsaw_add_photos_tour_showed', 'true')
  }

  useEffect(() => {
    if (visible) {
      sensors.track('web_workgroup_jigsaw_show_add_photo_tour')
    }
  }, [visible])

  const tourConfig = useMemo(
    () => [
      {
        selector: '.add-photos-area',
        content: (
          <div style={{ background: '#4E83FD', position: 'relative' }}>
            <p style={{ margin: 0 }}>点击此处添加拼图照片，完善汇报信息。</p>
            <button
              style={{
                marginTop: 10,
                background: '#ffffff',
                borderRadius: 2,
                border: 'none',
                outline: 'none',
                color: '#4E83FD',
                fontSize: 14,
                float: 'right'
              }}
              onClick={() => {
                sensors.track('web_workgroup_jigsaw_click', {
                  clickItem: 'add_photos_tour_close_btn'
                })
                onClose()
              }}
            >
              我知道了
            </button>
          </div>
        ),
        style: {
          background: '#4E83FD',
          padding: 20,
          fontSize: 16,
          color: '#fff'
        },
        position: 'top'
      }
    ],
    []
  )

  return (
    <Tour
      onRequestClose={() => {
        sensors.track('web_workgroup_jigsaw_click', {
          clickItem: 'add_photos_tour_mask'
        })
        onClose()
      }}
      isOpen={visible}
      steps={tourConfig}
      showNavigation={false}
      showNumber={false}
      showButtons={false}
      rounded={4}
      showCloseButton={false}
    />
  )
}

export default AddPhotoTour
